import { useAbortableGet } from '../../board/api/useAbortableGet';
import type { SearchSchema } from './searchTypes';

export function useSearchSchema() {
    return useAbortableGet<SearchSchema>('/api/markets/search/schema');
}